export default "__VITE_ASSET__DSPWlkZK__"